export { SalesRepModalDetailsComponent } from './sales-rep-modal-details.component';
